// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"465":"a13d1d92","584":"9fed483f"}[chunkId] + ".chunk.css";
};